import React from 'react';
import PropTypes from 'prop-types';

const ProjectCompetitorRenderer = ({ value = [] }) => (
  <>
    {(value || []).map((name, i) => (
      <span key={i} className="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-xl tw-text-[11px] tw-font-medium tw-bg-sky-100 tw-text-sky-700 tw-mr-1">
        {name}
      </span>
    ))}
  </>
);

ProjectCompetitorRenderer.propTypes = { value: PropTypes.arrayOf(PropTypes.string) };

export default ProjectCompetitorRenderer;
